import React from 'react'
import { TENANT_USER, ADMIN_USER } from '../../utils/constants'
import { useFetch } from "../../customHooks/fetchData"
import { getDashboardDataURL } from "../../utils/allurls"
import { getRentStatsFormattedData } from "../../utils/GeneralUtils"
import SparkleCard from '../../components/SparkleCard'


export default function RentStatsSummary(props) {

    //schedule-tenant-dashboard,schedule-admin-dashboard

    var requestURL = "rent-tenant-dashboard"

    if (props.user_type === TENANT_USER) {
        requestURL = "rent-tenant-dashboard"
    } else if (props.user_type === ADMIN_USER) { 
        requestURL = "rent-admin-dashboard"
    }
    const dashboardData = useFetch(getDashboardDataURL(requestURL))


    return (
        <>
            {dashboardData.success && getRentStatsFormattedData(dashboardData.data.data).map((item, i) => {
                return <SparkleCard
                    index={i+200}
                    key={i+200}
                    Heading={item.name}
                    Money={`${item.value}${item.valueType}`}
                    PerText={""}
                    isRandomUpdate={false}
                    mainData={item.sparklineData.data}
                    chartColor={item.sparklineData.areaStyle.color}
                    ContainerClass="col-lg-3 col-md-6 col-sm-6"
                />
            })}
        </>
    )
}
